import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { jumpPageUrl, getQuery } from '@src/utils';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';
import { type FeedFlowItem } from '@src/services/interface';

type TopicTextProps = {
    content: {
        text: FeedFlowItem['topicTitle'];
        topicId: FeedFlowItem['topicId'];
    };
};

const TopicText = ({ content }: TopicTextProps) => {
    const text = content?.text;
    const topicId = content?.topicId || '';
    const jumpHandle = () => {
        const userId = getQuery(window.location.href, 'userId') || '';

        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'b',
            user_id: userId,
        });
        jumpPageUrl('topic', topicId);
    };

    return text ? (
        <div onClick={jumpHandle} className={styles.topicText}>
            #{text}
        </div>
    ) : null;
};

export default errorBoundary(TopicText);
